import { isObject } from './is-object';

export function isEmptyObject<T>(predictable: T): boolean {
  if (isObject(predictable)) {
    return Object.keys(predictable).length === 0;
  }

  return false;
}
